import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { XCheckbox } from '@swordhealth/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordCheckbox',
  props: {
    value: { type: [Boolean, String, Number] },
    optValue: { type: [Boolean, String, Number], default: true }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit: __emit }) {

/**
 * Bridge component: Vue 2 compat → XCheckbox (Vue 3)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed, delete this file and map SwordCheckbox
 * directly to XCheckbox in global-components.ts
 *
 * Usage:
 *
 *   <sword-checkbox v-model="checked" @change="handleChange" />
 */


const emit = __emit

const handleUpdate = (newValue: boolean) => {
  emit('input', newValue)
  emit('change', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XCheckbox), _mergeProps(_ctx.$attrs, {
    "model-value": __props.value,
    "opt-value": __props.optValue,
    "vee-use-field": false,
    "onUpdate:modelValue": handleUpdate
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ], undefined, true),
    _: 3
  }, 16, ["model-value", "opt-value"]))
}
}

})